export default () => `composer require flagsmith/flagsmith-php-client
`
